import { render } from "./WaiterPOS.vue?vue&type=template&id=538f1824&scoped=true"
import script from "./WaiterPOS.vue?vue&type=script&lang=js"
export * from "./WaiterPOS.vue?vue&type=script&lang=js"

import "./WaiterPOS.vue?vue&type=style&index=0&id=538f1824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538f1824"]])

export default __exports__